import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useApproveMonthlyReportDialog } from "./dialogs";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

/**
 * The floating approve action, kept apart from the view so the dialog dispatch has a component to
 * live in. `PageFooter` renders it centred and sticky — the same shape as the Save action on a
 * settings form, which is what the advisor already recognises as "the thing this page is for".
 *
 * The button only opens the confirmation; approving itself happens in the dialog, because
 * publishing to the customer is not something a single click should do.
 */
const MonthlyReportApproveFooter: React.FC<{ reportId: string; onApproved: () => void }> = ({
  reportId,
  onApproved,
}) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const getApproveDialog = useApproveMonthlyReportDialog(reportId);

  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.ApproveAndShare),
          type: StyleEnums.DisplayType.Success,
          testId: "approveReport",
          onClick: () => {
            dispatch(displayDialog(getApproveDialog(onApproved)));
            return Promise.resolve();
          },
        },
      ]}
    />
  );
};

export default MonthlyReportApproveFooter;
